<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <div>
                    <h5>Asigne preguntas a los puestos</h5>
                    <h5>Preguntas Asignadas</h5>
                    <div class="">
                        <button class="boton botonSM filledBlanco" (click)="AgregarPregunta()">
                            <span> {{'Agregar otras Preguntas'}}</span>
                        </button>
                    </div>
                    <!-- datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="ListPreguntas"
                            [showColumnHeaders]="true"
                            [noDataText]="'Sin Datos'"
                            (onSelectionChanged)="onSelectionChanged($event)"
                            [(selectedRowKeys)]="selectedRows"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                            
                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                            <dxi-column
                            alignment="center"
                            dataField="Activo"
                            dataType="boolean"
                            >
                            </dxi-column>
                            <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="clave"
                                caption="Clave"
                                alignment="left">
                            </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="competencia"
                                caption="Competencia">
                            </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="criterio"
                                caption="Criterio">
                            </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="pregunta"
                                caption="Pregunta">
                            </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="tipopregunta"
                                caption="Tipo de pregunta">
                            </dxi-column>
                            <dxi-column [allowEditing]="false"
                                dataField="nivel"
                                caption="Nivel">
                            </dxi-column>

                            <div *dxTemplate="let cell of 'cellAcciones'">
                                    <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data.periodoevaluacionpuestoporpreguntaid)" *ngIf="sistemaService.permisos.eliminar && cell.data.Seccionid != '2'">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<relacionPregunta #preguntaimportar (respuesta)="PreguntasNuevas($event)"></relacionPregunta>